import { productSelectors } from '@ynap/product-state';

const { getPrice, getProductAvailability } = productSelectors;

/* Keep */
export const getSelectedProductPrice = (product, currencyConversion = {}, userCountry) => {
    const price = getPrice(product.price, 'sellingPrice');

    const availability = getProductAvailability(product);

    const { currency, finalPrice } = price;

    const { rates } = currencyConversion;

    const usersCurrency = currencyMap[userCountry];

    if (rates && usersCurrency && currency) {
        // currencyConversion data is allways in elzibeths (GBP)
        // First change the product price into GBP, and then from GBP into the users target currency

        // rate to change current price into GBP
        const startRate = Number(rates[currency.label]);

        // rate to change GBP into target price
        const targetRate = Number(rates[usersCurrency]);

        const exchangePrice = Math.round((finalPrice / startRate) * targetRate);

        // TODO: Remove this when/if API sends us the info - https://jira.nap/browse/SPEOISNRS-4379
        // rate to change GBP into user country threshold currency
        let ddpIncludedThreshold = false;

        if (thresholdMap[userCountry]) {
            const userCountryThresholdCurrency = thresholdMap[userCountry].currency;
            const targetRateThreshold = Number(rates[userCountryThresholdCurrency]);
            const exchangePriceThreshold = Math.round((finalPrice / startRate) * targetRateThreshold);
            ddpIncludedThreshold = exchangePriceThreshold > thresholdMap[userCountry].value;
        }

        return {
            ...price,
            availability,
            exchangePrice,
            exchangeCurrency: currency.label !== usersCurrency ? usersCurrency : null, // dont return exchangeCurrency if currency matches
            ddpIncludedThreshold,
        };
    }

    return {
        ...price,
        availability,
    };
};

const currencyMap = {
    AD: 'EUR',
    AE: 'AED',
    AF: 'AFN',
    AG: 'XCD',
    AL: 'ALL',
    AM: 'AMD',
    AN: 'ANG',
    AO: 'AOA',
    AR: 'ARS',
    AT: 'EUR',
    AU: 'AUD',
    AW: 'AWG',
    AZ: 'AZN',
    BA: 'BAM',
    BB: 'BBD',
    BD: 'BDT',
    BE: 'EUR',
    BG: 'BGN',
    BH: 'BHD',
    BL: 'EUR',
    BM: 'BMD',
    BN: 'BND',
    BO: 'BOB',
    BR: 'BRL',
    BS: 'BSD',
    BT: 'BTN',
    BW: 'BWP',
    BY: 'BYN',
    BZ: 'BZD',
    CA: 'CAD',
    CH: 'CHF',
    CI: 'XOF',
    CK: 'NZD',
    CL: 'CLP',
    CN: 'CNY',
    CO: 'COP',
    CR: 'CRC',
    CV: 'CVE',
    CY: 'EUR',
    CZ: 'CZK',
    DE: 'EUR',
    DK: 'DKK',
    DM: 'XCD',
    DO: 'DOP',
    DZ: 'DZD',
    EE: 'EUR',
    EG: 'EGP',
    ES: 'EUR',
    FI: 'EUR',
    FJ: 'FJD',
    FK: 'FKP',
    FO: 'DKK',
    FR: 'EUR',
    GA: 'XAF',
    GB: 'GBP',
    GD: 'XCD',
    GE: 'GEL',
    GG: 'GBP',
    GH: 'GHS',
    GI: 'GIP',
    GL: 'DKK',
    GM: 'GMD',
    GR: 'EUR',
    GT: 'GTQ',
    GY: 'GYD',
    HK: 'HKD',
    HN: 'HNL',
    HR: 'HRK',
    HU: 'HUF',
    IC: 'EUR',
    ID: 'IDR',
    IE: 'EUR',
    IL: 'ILS',
    IN: 'INR',
    IS: 'ISK',
    IT: 'EUR',
    JE: 'GBP',
    JM: 'JMD',
    JO: 'JOD',
    JP: 'JPY',
    KE: 'KES',
    KG: 'KGS',
    KH: 'KHR',
    KM: 'KMF',
    KN: 'XCD',
    KR: 'KRW',
    KW: 'KWD',
    KY: 'KYD',
    KZ: 'KZT',
    LA: 'LAK',
    LB: 'LBP',
    LC: 'XCD',
    LI: 'CHF',
    LK: 'LKR',
    LR: 'LRD',
    LS: 'LSL',
    LT: 'EUR',
    LU: 'EUR',
    LV: 'EUR',
    MA: 'MAD',
    MC: 'EUR',
    MD: 'MDL',
    ME: 'EUR',
    MG: 'MGA',
    MK: 'MKD',
    MN: 'MNT',
    MO: 'MOP',
    MS: 'XCD',
    MT: 'EUR',
    MU: 'MUR',
    MV: 'MVR',
    MW: 'MWK',
    MX: 'MXN',
    MY: 'MYR',
    MZ: 'MZN',
    NA: 'NAD',
    NC: 'XPF',
    NI: 'NIO',
    NL: 'EUR',
    NO: 'NOK',
    NP: 'NPR',
    NZ: 'NZD',
    OM: 'OMR',
    PA: 'PAB',
    PE: 'PEN',
    PF: 'XPF',
    PG: 'PGK',
    PH: 'PHP',
    PL: 'PLN',
    PT: 'EUR',
    PY: 'PYG',
    QA: 'QAR',
    RO: 'RON',
    RS: 'RSD',
    RU: 'RUB',
    SA: 'SAR',
    SB: 'SBD',
    SC: 'SCR',
    SE: 'SEK',
    SG: 'SGD',
    SI: 'EUR',
    SK: 'EUR',
    SM: 'EUR',
    SN: 'XOF',
    SR: 'SRD',
    ST: 'STD',
    SV: 'SVC',
    SY: 'SYP',
    SZ: 'SZL',
    TG: 'XOF',
    TH: 'THB',
    TJ: 'TJS',
    TM: 'TMT',
    TN: 'TND',
    TO: 'TOP',
    TR: 'TRY',
    TT: 'TTD',
    TV: 'AUD',
    TW: 'TWD',
    TZ: 'TZS',
    UA: 'UAH',
    US: 'USD',
    UY: 'UYU',
    UZ: 'UZS',
    VC: 'XCD',
    VE: 'VEF',
    VN: 'VND',
    VU: 'VUV',
    WS: 'WST',
    ZA: 'ZAR',
    ZW: 'ZWL',
};

// TODO: Remove this when/if API sends us the info - https://jira.nap/browse/SPEOISNRS-4379
const thresholdMap = {
    KR: {
        // South Korea
        value: 150,
        currency: 'USD',
    },
    AU: {
        // Australia
        value: 1000,
        currency: 'AUD',
    },
    JP: {
        // Japan
        value: 10000,
        currency: 'JPY',
    },
    SG: {
        // Singapore
        value: 400,
        currency: 'SGD',
    },
    PH: {
        // Phillipines
        value: 10000,
        currency: 'PHP',
    },
    SA: {
        // Saudi Arabia
        value: 1000,
        currency: 'SAR',
    },
    AE: {
        // United Arab Emirates
        value: 1000,
        currency: 'AED',
    },
    BH: {
        // Bahrain
        value: 300,
        currency: 'BHD',
    },
    BN: {
        // Brunei
        value: 400,
        currency: 'BND',
    },
    JE: {
        // Jersey
        value: 240,
        currency: 'GBP',
    },
    JO: {
        // Jordan
        value: 100,
        currency: 'JOD',
    },
    MY: {
        // Malaysia
        value: 500,
        currency: 'MYR',
    },
    NO: {
        // Norway
        value: 350,
        currency: 'NOK',
    },
    TW: {
        // Taiwan
        value: 2000,
        currency: 'TWD',
    },
    ZA: {
        // South Africa
        value: 500,
        currency: 'ZAR',
    },
    TH: {
        // Thailand
        value: 1500,
        currency: 'THB',
    },
    NZ: {
        // New Zealand
        value: 1000,
        currency: 'NZD',
    },
};
